import { render, staticRenderFns } from "./DateRange.vue?vue&type=template&id=f97a6486&scoped=true&"
import script from "./DateRange.vue?vue&type=script&lang=js&"
export * from "./DateRange.vue?vue&type=script&lang=js&"
import style0 from "./DateRange.vue?vue&type=style&index=0&id=f97a6486&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f97a6486",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f97a6486')) {
      api.createRecord('f97a6486', component.options)
    } else {
      api.reload('f97a6486', component.options)
    }
    module.hot.accept("./DateRange.vue?vue&type=template&id=f97a6486&scoped=true&", function () {
      api.rerender('f97a6486', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2B72eL5gGpKkp/JS/comp/DateRange.vue"
export default component.exports